import { DependencyList, useEffect, useRef } from 'react';

export const useConstant = <T>(
  factory: () => T,
  deps: DependencyList = [],
): T => {
  const mountRef = useRef(false);
  const valueRef = useRef<T | undefined>(undefined);
  if (!valueRef.current) {
    valueRef.current = factory();
  }
  useEffect(() => {
    if (!mountRef.current) {
      mountRef.current = true;
    } else {
      valueRef.current = factory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return valueRef.current;
};
